import { createSlice } from "@reduxjs/toolkit";
const initailState={
  values: {
    file: "",
    fileName:"",
    bucketName:"",
    fileType:""
  }
}

export const objectStoreSlice = createSlice({
  
  name: "objectStore",
  initialState: initailState,
  reducers: {
    objectStore: (state, action) => {
     state.values +=action.payload
    },
  },
});

export const { objectStore } = objectStoreSlice.actions;
export default objectStoreSlice.reducer;
